enum DraggableOverlaySize {
  SMALL = 'sm',
  LARGE = 'lg',
}

export default DraggableOverlaySize;
